export const API_PATH_ApiDeviceMgmtPingPongSubscriptionPost = '/services/devices-mgtm/apiDeviceMgmtPingPongSubscriptionPost';
